import { getCurrentQuery, getData, mhandHttps } from "../../utils.js";
import { addAddressCard } from "./addAddressCard.js";
import { addProductOrderCard } from "./addProductOrderCard.js";

export async function getInfo() {
    const orderForm = document.querySelector('#order-form');
    if(!orderForm) return;
    const orderId = getCurrentQuery()[0].order_id;
    
    const res = await getData(`${mhandHttps}api/order/${orderId}/?source=details`);
    const productsContainer = document.querySelector('.__products_order__container');
    if(productsContainer) {
        const fragment = document.createDocumentFragment();
        const promises = res.items.map(async(item)=>{
            const card = await addProductOrderCard(item);
            fragment.appendChild(card);
        });
        Promise.all(promises).then(()=>productsContainer.appendChild(fragment))
    };
    
    const loyaltyBlock = document.querySelector('.order-section__card__loyality-block');
    if(loyaltyBlock) {
        const resLoyalty = await getData(`${mhandHttps}api/profile/get-card-info/`);
        for(const [key, value] of Object.entries(resLoyalty)) {
            const items = document.querySelectorAll(`[data-loyalty="${key}"]`);
            if(items.length > 0) {
                items.forEach(item=>{
                    if(item.tagName.toLowerCase() === 'span') {
                            const oldInner = item.innerHTML;
                        if(!!Date.parse(value) && typeof value === 'string') {
                            item.innerHTML = new Date(Date.parse(value)).toLocaleDateString('ru-RU');
                        } else {
                            item.innerHTML = value + oldInner;
                        };
                    };
                });
            };
        };
    };

    const addressOrderList = document.querySelector('.__address_order__list');
    if(addressOrderList) {
        const addressesRes = await getData(`${mhandHttps}api/profile-address/`);
        if(addressesRes.results.length > 0) {
            const fragment = document.createDocumentFragment();
            const promises = addressesRes.results.map(async(item)=>{
                const card = await addAddressCard(item);
                fragment.appendChild(card);
            });
            Promise.all(promises).then(()=>{
                addressOrderList.appendChild(fragment);
            });
        };
    };
}